module.exports = {"540330100":"边坝镇","540330101":"草卡镇","540330201":"沙丁乡","540330202":"金岭乡","540330203":"加贡乡","540330204":"马武乡","540330205":"热玉乡","540330206":"尼木乡","540330207":"马秀乡","540330208":"拉孜乡","540330209":"都瓦乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540330.json
// module id = 2851
// module chunks = 0